import { Duration, DurationEnum, Pricing } from '@core/models/plan.model';

/** Resolves pricing.monthly / pricing.yearly from billing cycle enum (MONTHLY / YEARLY). */
export function getPricingAmountForDuration(price: Pricing, duration: Duration): number | null {
  const amount = duration === DurationEnum.Yearly ? price.yearly : price.monthly;
  return amount ?? null;
}

export function toBillingCycleEnum(value?: string | Duration | null): Duration {
  const normalized = String(value ?? '').toUpperCase();
  return normalized === DurationEnum.Yearly ? DurationEnum.Yearly : DurationEnum.Monthly;
}

export function calculateYearlyPrice(monthly: number, discount: number): number {
  if (!monthly) return 0;
  const yearly = monthly * 12 * (1 - discount / 100);
  return Math.round(yearly / 12);
}

export function calculateDiscount(monthly: number, yearly: number): number {
  if (!monthly || !yearly) return 0;
  const totalMonthly = monthly * 12;
  const totalYearly = yearly * 12;
  return Math.round(((totalMonthly - totalYearly) / totalMonthly) * 100);
}

export function formatPlanPrice(value: number | null | undefined, currency = 'USD'): string {
  if (value === 0) return 'Free';
  if (value === -1) return '∞';
  if (value == null) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value);
}
